<template>
  <v-app id="cheerfulgive-record">
    <v-container fluid class="mb-8">
      <!-- 上方按鈕 -->
      <div>
        <v-btn color="blue" elevation="2" outlined x-large class="text-h6" @click="back">
          <icon-reply class="cheerfulgive-icon" />
          {{ $t('backToCheckout') }}
        </v-btn>
      </div>

      <!-- 商店 + 日期 -->
      <div class="mt-13">
        <v-row justify="space-between">
          <v-col cols="5">
            <v-select
              color="pimary"
              v-model="storeId"
              :items="stores"
              :label="$t('pleaseSelectStore')"
              item-text="nameWithType"
              item-value="id"
              full-width
              outlined>
              <template v-slot:append>
                <v-icon color="primary">$dropdown</v-icon>
              </template>
            </v-select>
          </v-col>
          <v-col cols="auto">
            <div class="ml-auto">
              <div class="text-h6 primary--text">{{ $t('today') }}：</div>
              <div class="text-h6">{{ today }}</div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div class="text-center" v-show="loading">
        <v-progress-circular
          :size="70"
          color="primary"
          indeterminate
          class="mx-auto my-10"
        ></v-progress-circular>
      </div>

      <div class="text-center text-h4 my-4 primary--text" v-show="!loading && records.length <= 0">
        {{ $t('noData') }}
      </div>

      <div v-if="!loading && records.length > 0">
        <!-- 紀錄表格 -->
        <div class="mt-16">
          <v-simple-table id="record-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('orderNumber') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('orderDateCreated') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('payerLastName') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('payerFirstName') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('paymentTool') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('orderAmount') }}</th>
                  <th class="text-center text-h6 primary--text th-border">{{ $t('orderCreatedBy') }}</th>
                  <th v-if="showPrint" class="text-center text-h6 primary--text th-border">{{ $t('receipt') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record, index in records" :key="index">
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ record.orderNumber }}</td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border" v-html="record.dateCreated.replace(' ', '<br />')"></td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ record.payerLastName }}</td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ record.payerFirstName }}</td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ record.paymentTool }}</td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ new Intl.NumberFormat('en-US', {style: 'decimal'}).format(record.amount) }}</td>
                  <td class="text-center text-body-1 secondary--text py-8 td-border">{{ record.createdByName }}</td>
                  <td v-if="showPrint" class="text-center text-body-1 secondary--text py-8 td-border">
                    <v-btn v-if="record.receiptTypeCode === 'BY_TIME'" color="primary" elevation="2" @click="receiptPrint(record.id)">
                      <v-icon dense class="mr-1">mdi-printer</v-icon>
                      {{ $t('print') }}
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <!-- 合計 -->
        <div class="th-border py-5">
          <div v-for="paymentTool in Object.keys(totals)" :key="paymentTool">
            <v-row justify="end" v-if="totals[paymentTool] > 0">
              <v-col cols="auto" class="text-body-1">{{ paymentTool }}： TWD</v-col>
              <v-col cols="1" class="text-body-1 primary--text text-right">{{ numberFormat(totals[paymentTool]) }}</v-col>
            </v-row>
          </div>
        </div>
        <v-row justify="end">
          <v-col cols="auto" class="py-8 text-body-1">{{ $t('total') }}： TWD</v-col>
          <v-col cols="1" class="py-8 text-body-1 primary--text text-right">{{ total }}</v-col>
        </v-row>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import api from '../apis'
import helper from '../helper'

import IconReply from '@/assets/icons/reply.vue'

// if (this.form.store.isReceiptDuctable || this.form.store.isReceiptDisductable)
export default {
  name: 'PosRecord',
  components: {
    IconReply
  },
  data () {
    return {
      loading: false,
      today: new Date().toLocaleDateString('zh-tw'),
      stores: [],
      storeId: '',
      records: [],
      paymentTools: []
    }
  },
  computed: {
    totals () {
      // 各收款方式加總 reduce
      const totals = {}
      this.paymentTools.forEach(paymentTool => {
        totals[paymentTool] = this.records.reduce((total, record) => {
          return total + (record.paymentTool === paymentTool ? record.amount : 0)
        }, 0)
      })

      return totals
    },
    total () {
      // 全部金額加總 reduce
      if (!this.records || this.records.length === 0) return 0

      const total = this.records.reduce((total, record) => {
        return total + record.amount
      }, 0)

      return helper.number.format(total)
    },
    store () {
      return this.stores.find(store => store.id === this.storeId)
    },
    showPrint () {
      if (this.store.isReceiptDuctable || this.store.isReceiptDisductable) {
        // 收據類
        return true
      } else {
        // 非收據
        return false
      }
    }

  },
  watch: {
    async storeId (newVal) {
      if (!newVal) return false

      this.loading = true

      // 1. 商店改變重新整理付款方式
      const paymentTools = await api.paymentTool.findAllByStoreId(newVal)
      this.paymentTools = paymentTools.data.map(paymentTool => paymentTool.name)

      // 2. 商店改變重新整理記錄
      const records = await api.order.summary(newVal)
      this.records = records.data.map(record => {
        record.dateCreated = new Date(record.dateCreated).toLocaleString('zh-tw')
        return record
      })

      this.loading = false
    }
  },
  created () {
    // 讀取商店清單並預設
    api.store.list()
      .then(res => {
        this.stores = res.data.filter(store => store.channelType === 'OFFLINE')
        this.stores = this.stores.map(store => {
          store.nameWithType = store.name + ' ' + helper.store.getStoreDescription(store)
          return store
        })

        // 預設同登打商店或第一間商店
        if (this.$route.params.storeId) {
          this.storeId = this.$route.params.storeId
        } else if (this.stores.length > 0) {
          this.storeId = this.stores[0].id
        }
      })
  },
  methods: {
    numberFormat (value) {
      return helper.number.format(value)
    },
    back () {
      // 返回登打畫面
      this.$router.push('/checkout')
    },
    receiptPrint (orderId) {
      // 列印收據
      this.$router.push(`/receipt-print?orderId=${orderId}&isReissuedPrint=1`)
    }
  }
}
</script>

<style lang="scss" scoped>
.th-border {
  border-bottom-width: 2px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-base) !important;
}
.td-border {
  border-bottom-width: 1px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-lighten2) !important;
}
#record-table tbody tr:hover {
  background-color: var(--v-primary-lighten2) !important;
}
</style>
